import cx from "classnames";
import React, { useEffect, useState } from "react";

import { ImageBlock, MathBlock } from "../../../types";
import { Props } from "../types";
import { extractTextBlock } from "../util";


export const InnodomImage = ({
  block,
  fontInformation,
  onSelectBlock,
  pages,
  referencesLink,
  selected,
}: Props<ImageBlock | MathBlock>) => {
  const { height, width, page, x, y } = block;
  const [dataUri, setDataUri] = useState<string | null>(null);
  useEffect(() => {
    const currentPage = pages[page];
    if (currentPage.src === undefined) {
      return;
    }
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.src = currentPage.src;
    image.onload = () => {
      const scale = image.naturalHeight / (currentPage.height as number);
      if (isNaN(scale)) {
        return;
      }
      const canvas = document.createElement("canvas");
      canvas.width = width * scale;
      canvas.height = height * scale;
      const context = canvas.getContext("2d");
      if (!context) {
        return;
      }
      context.drawImage(
        image,
        x * scale,
        y * scale,
        width * scale,
        height * scale,
        0,
        0,
        width * scale,
        height * scale,
      );
      setDataUri(canvas.toDataURL());
    };
  }, []);
  if (dataUri === null) {
    return null;
  }
  const styles = {
    height: "auto",
    maxWidth: "100%",
    width: "auto",
  };
  return (
    <div
      className={cx("block", "d-inline-block", "p-2", { selected }, block.confidenceClass)}
      key={`block-${block.id}`}
      id={`support-${block.id}`}
      onClick={e => {
        e.preventDefault();
        if (!onSelectBlock) {
          return;
        }
        onSelectBlock(block.id, block.text, e.ctrlKey);
      }}
    >
      <img className="d-block" src={dataUri} style={styles} />
      {extractTextBlock(block.element)}
      {referencesLink}
    </div>
  );
};
InnodomImage.displayName = "InnodomImage";
